import * as React from "react";
import type { SVGProps } from "react";
const SvgTransferassetsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="transferassets_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M776.96 682.667 636.501 823.168a42.667 42.667 0 0 0 60.331 60.33l213.333-213.333-2.901-1.194c9.557-7.595 15.403-17.792 15.403-28.971 0-23.552-25.942-42.667-57.899-42.667h-694.87c-32 0-57.898 19.115-57.898 42.667s25.941 42.667 57.899 42.667h607.104zM398.208 200.832 257.707 341.333H864.81c32 0 57.898 19.115 57.898 42.667s-25.941 42.667-57.898 42.667H169.899c-32 0-57.899-19.115-57.899-42.667 0-11.179 5.845-21.333 15.36-28.97l-2.859-1.195L337.835 140.5a42.667 42.667 0 0 1 60.33 60.331z"
    />
  </svg>
);
export default SvgTransferassetsIcon;
